module.exports = __webpack_public_path__ + "img/自卸车.e2e38d81.jpg";